export default 'DD/MM/YYYY [às] HH:mm';
